import { TwoFactorAuthenticationTypes } from "global/enums";
import { verifyOneTimePassword, verifyTwoFactorAuthEmailSetup } from "./TwoFactorAuthenticationSlice";
import TwoFactorEmailDisplay from "./TwoFactorEmailDisplay";
import TwoFactorAppDisplay from "./TwoFactorAppDisplay";
import { TwoFactorAuthSetupModel } from "services/api/cplauthapi/CPLAuthAPI";

export const getTwoFactorAuthText = (twoFactorAuthType: TwoFactorAuthenticationTypes) => {
  switch (twoFactorAuthType) {
    case TwoFactorAuthenticationTypes.Email:
      return "email";
    case TwoFactorAuthenticationTypes.TOTP:
      return "app";
  }
};

export const getTwoFactorVerificationFunction = (authenticatorType, oneTimePassword) => {
  switch (authenticatorType) {
    case TwoFactorAuthenticationTypes.Email:
      return verifyTwoFactorAuthEmailSetup(oneTimePassword);
    case TwoFactorAuthenticationTypes.TOTP:
      return verifyOneTimePassword(oneTimePassword);
    default:
      throw new Error("Invalid authentication type");
  }
};

export const getTwoFactorAuthString = (twoFactorAuthType: TwoFactorAuthenticationTypes) => {
  switch (twoFactorAuthType) {
    case TwoFactorAuthenticationTypes.Email:
      return "Email Authentication";
    case TwoFactorAuthenticationTypes.TOTP:
      return "Authenticator App";
  }
};

export const getTwoFactorAuthDisplay = (
  twoFactorAuthSetupData: TwoFactorAuthSetupModel,
  authenticatorType: TwoFactorAuthenticationTypes
) => {
  switch (authenticatorType) {
    case TwoFactorAuthenticationTypes.Email:
      return <TwoFactorEmailDisplay />;
    case TwoFactorAuthenticationTypes.TOTP:
      return <TwoFactorAppDisplay setupData={twoFactorAuthSetupData} />;
  }
};

export const getOtherAuthenticatorTypes = (currentAuthenticatorType: TwoFactorAuthenticationTypes) => {
  return Object.values(TwoFactorAuthenticationTypes)
    .filter((x) => {
      if (isNaN(Number(x)) || x === currentAuthenticatorType) return false;
      return x !== 0;
    })
    .map((x) => {
      return x as TwoFactorAuthenticationTypes;
    });
};

export const getAllValidAuthenticatorTypes = () => {
  return Object.values(TwoFactorAuthenticationTypes)
    .filter((x) => {
      if (isNaN(Number(x))) return false;
      return x !== 0;
    })
    .map((x) => {
      return x as TwoFactorAuthenticationTypes;
    });
};
